import {
    SAVE_FILTER_DATA
   } from "../actions/actionTypes";
   
  const DEFAULT_STATE = {
    filterData: {}
  };
  
  export default (state = DEFAULT_STATE, action) => {
    switch (action.type) {
      case SAVE_FILTER_DATA:
        return {
          ...state,
          filterData: action.filterData
        };
      default:
        return state;
    }
  }; 
   